module.exports = __webpack_public_path__ + "img/fugalidad.fc98f157.png";